/**
 * Landing background handling particles.js
 * Sets the interactivity of the background
 * Hover = grab
 * Click = repulse
 */
import React from 'react';

import Particles from 'react-particles-js';

const backgroundParams = {
  "particles": {
    "number": {
      "value": 20
    },
    "size": {
      "value": 3
    }
  },
  "interactivity": {
    "events": {
      "onhover": {
        "enable": true,
        "mode": "grab"
      },
      "onclick": {
        "enable": true,
        "mode": "repulse"
      },
    },
  }
}

export default function LandingBackground () {
  return (
    <Particles 
      canvasClassName="background-canvas"
      params={backgroundParams}
    />
  );
}

